function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M110.581 0a3.274 3.274 0 0 0-3.267 3.267 3.24 3.24 0 0 0 3.254 3.254c31.671-.069 61.452 12.237 83.86 34.645 22.408 22.407 34.712 52.188 34.646 83.858a3.243 3.243 0 0 0 3.254 3.253 3.273 3.273 0 0 0 3.266-3.265c.072-33.41-12.91-64.83-36.546-88.467C175.478 12.975 144.17 0 110.861 0h-.28z"
}), /*#__PURE__*/React.createElement("path", {
  id: "b",
  d: "M110.527 27.109a3.275 3.275 0 0 0-3.268 3.268 3.242 3.242 0 0 0 3.254 3.253c50.53-.109 91.553 40.914 91.447 91.447a3.243 3.243 0 0 0 3.255 3.255 3.275 3.275 0 0 0 3.267-3.268c.115-54.048-43.714-97.951-97.745-97.955h-.21z"
}), /*#__PURE__*/React.createElement("path", {
  id: "c",
  d: "M110.47 54.224a3.275 3.275 0 0 0-3.268 3.269 3.24 3.24 0 0 0 3.254 3.253c17.206-.034 33.388 6.65 45.565 18.827 12.176 12.176 18.86 28.358 18.826 45.565a3.24 3.24 0 0 0 .95 2.303c.59.59 1.404.952 2.303.95a3.274 3.274 0 0 0 3.268-3.268c.041-18.947-7.32-36.768-20.725-50.172-13.372-13.372-31.135-20.727-50.03-20.727h-.143z"
}), /*#__PURE__*/React.createElement("path", {
  id: "d",
  d: "M110.994 95.234c-7.605 7.604-7.762 19.816-.355 27.223 7.41 7.408 19.621 7.251 27.224-.353 7.604-7.603 7.762-19.815.353-27.224-3.64-3.641-8.44-5.454-13.285-5.454-5.012 0-10.07 1.941-13.937 5.808zm3.855 23.012c-5.146-5.148-5.034-13.63.248-18.912 5.282-5.282 13.767-5.393 18.912-.248 5.146 5.146 5.038 13.633-.245 18.915a13.69 13.69 0 0 1-9.683 4.035c-3.366 0-6.702-1.261-9.232-3.79z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(4)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#7D7C97",
  d: "M123.334 200.712c6.49.567 12.568.714 16.726-5.164 2.926-4.135 3.083-12.479.153-16.56-4.234-5.894-10.528-5.03-16.879-4.897v26.621zm-7 6.259v-38c6.196.296 12.34.02 18.259 1.004 9.226 1.532 13.628 7.484 13.74 17.032.11 9.493-5.324 16.987-14.442 18.669-5.629 1.037-11.488.89-17.557 1.295zM68.334 206.478c-4.786 1.066-8.043.657-9.875-3.79-1.01-2.45-2.778-4.602-4.214-6.884-1.893-3.01-4.464-4.667-8.85-3.771v14.644h-6.06v-36.573c5.364 0 10.81-.364 16.176.11 4.642.411 7.69 3.787 8.23 7.757.753 5.542-1.385 8.862-7.272 11.635l11.865 16.872zM73 168.804h20.759l.241 4.998H79.571v11.817h12.992v5.242H79.365v15.943H73v-38zM107 168.804v38h-6v-37.736l6-.264"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M123 201.536v-27.608c6.351-.137 12.644-1.033 16.88 5.08 2.93 4.231 2.772 12.884-.155 17.172-4.157 6.095-10.236 5.943-16.725 5.356M45 186.613v-12.506c3.797.038 8.123-1.532 10.9 2.127 1.225 1.615 1.443 4.989.572 6.889-2.113 4.608-6.764 3.651-11.472 3.49"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#7D7C97",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7,
  d: "M69.902 60.804H11.977C5.39 60.804 0 66.079 0 72.526v160.556c0 6.448 5.39 11.722 11.977 11.722h164.046c6.587 0 11.977-5.274 11.977-11.722V167.06"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#7D7C97",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#7D7C97",
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#7D7C97",
  xlinkHref: "#c"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#7D7C97",
  xlinkHref: "#d"
}));

function SvgRfidGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 240,
    height: 249,
    viewBox: "0 0 240 249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfidGray);
export default __webpack_public_path__ + "static/media/rfid-gray.82127aa2.svg";
export { ForwardRef as ReactComponent };